import { createSlice } from "@reduxjs/toolkit";
import { Status, } from "../types/LoyaltyCore.types";
import { fetchPointsHistory } from "./loyaltyCore/fetchPointsHistory";
import { fetchPointsHistoryReferral } from "./loyaltyCore/fetchReferralHistory";
import { fetchUserLoyaltyProfile } from "./loyaltyCore/fetchUserLoyaltyProfile";
import { fetchUserPoints } from "./loyaltyCore/fetchUserPoints";
import { handleUser } from "./loyaltyCore/handleUser";
export const initialHistoryPoints = {
    isLoaded: false,
    items: [],
    total: 0,
    statusCode: 0,
};
export const initialHistoryReferral = {
    isLoaded: false,
    items: [],
    total: 0,
};
export const initialReferralStats = {
    earned_points: 0,
    referees_count: 0,
    completed_first_order_count: 0,
};
export const initialTier = {
    name: "",
    image_url: "",
    next_tier_name: "",
    points_to_next_tier: 0,
    current_tier_assignment_date: "",
    cumulative_points: 0,
    points_to_maintain_current_tier: 0,
    current_tier_secured_till: "",
};
export const pointsInitial = { balance: 0, status: Status.IDLE, expire_at: "", points_to_expire: 0 };
export const initialLoyaltyReminderState = {
    hasFirstPurchase: false,
    parentCodeExists: false,
};
export const initialStateLoyaltyCore = {
    name: "",
    surname: "",
    points: pointsInitial,
    rewards: 0,
    ciamToken: "",
    code: "",
    tier: initialTier,
    referrees: [
        {
            createdAccount: true,
            completedFirstOrder: false,
        },
    ],
    referralStats: initialReferralStats,
    historyPoints: initialHistoryPoints,
    historyReferral: initialHistoryReferral,
    isLoaded: false,
    isLogged: false,
    isRestricted: false,
    isReferralOn: false,
    isUserDataFetching: false,
    reminder: initialLoyaltyReminderState,
};
export const loyaltyCore = createSlice({
    name: "loyaltyCore",
    initialState: initialStateLoyaltyCore,
    reducers: {
        setLoggedState: (state, { payload }) => {
            state.isLogged = payload;
        },
        setLoadedState: (state, { payload }) => {
            state.isLoaded = payload;
        },
        setRestrictedState: (state, { payload }) => {
            state.isRestricted = payload;
        },
        setUser: (state, { payload }) => {
            state.name = payload.name || state.name;
            state.surname = payload.surname || state.surname;
            state.ciamToken = payload.ciamToken || state.ciamToken;
            state.code = payload.code || state.code;
            state.referralStats = payload.referralStats || state.referralStats;
            state.tier = payload.tier || state.tier;
        },
        setReferralStatus: (state, { payload }) => {
            state.isReferralOn = payload;
        },
        setLoyaltyReminder: (state, action) => {
            if (action.payload.hasFirstPurchase !== undefined) {
                state.reminder.hasFirstPurchase = action.payload.hasFirstPurchase;
            }
            if (action.payload.parentCodeExists !== undefined) {
                state.reminder.parentCodeExists = action.payload.parentCodeExists;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPointsHistory.fulfilled, (state, { payload }) => {
            state.historyPoints = {
                isLoaded: payload.isLoaded,
                items: payload.items ? [...state.historyPoints.items, ...payload.items] : [...state.historyPoints.items],
                total: payload.total ? payload.total : state.historyPoints.total,
                statusCode: payload.statusCode,
            };
        });
        builder.addCase(fetchPointsHistory.rejected, (state, { payload }) => {
            var _a;
            state.historyPoints.isLoaded = true;
            state.historyPoints.message = payload === null || payload === void 0 ? void 0 : payload.message;
            state.historyPoints.statusCode = (_a = payload === null || payload === void 0 ? void 0 : payload.code) !== null && _a !== void 0 ? _a : 0;
        });
        builder.addCase(fetchPointsHistoryReferral.fulfilled, (state, { payload }) => {
            state.historyReferral = {
                items: payload.items ? [...state.historyReferral.items, ...payload.items] : [...state.historyReferral.items],
                total: payload.total ? payload.total : state.historyReferral.total,
                isLoaded: true,
            };
        });
        builder.addCase(fetchPointsHistoryReferral.rejected, (state) => {
            state.historyReferral.isLoaded = true;
        });
        builder.addCase(fetchUserPoints.pending, (state) => {
            state.points.status = Status.PENDING;
        });
        builder.addCase(fetchUserPoints.fulfilled, (state, { payload }) => {
            state.points = payload;
        });
        builder.addCase(fetchUserPoints.rejected, (state) => {
            state.points.status = Status.FAILED;
        });
        builder.addCase(fetchUserLoyaltyProfile.pending, (state) => {
            state.points.status = Status.PENDING;
        });
        builder.addCase(fetchUserLoyaltyProfile.fulfilled, (state, { payload }) => {
            state.points = payload.points;
            state.tier = payload.tier;
        });
        builder.addCase(fetchUserLoyaltyProfile.rejected, (state) => {
            state.points.status = Status.FAILED;
        });
        builder.addCase(handleUser.pending, (state) => {
            state.isUserDataFetching = true;
        });
        builder.addCase(handleUser.fulfilled, (state) => {
            state.isUserDataFetching = false;
        });
        builder.addCase(handleUser.rejected, (state) => {
            state.isUserDataFetching = false;
        });
    },
});
export const { setLoggedState, setLoadedState, setRestrictedState, setUser, setReferralStatus, setLoyaltyReminder } = loyaltyCore.actions;
export default loyaltyCore.reducer;
//# sourceMappingURL=loyaltyCore.js.map